import React from "react";
import { history } from "../../History";
import { connect } from "react-redux";
import Routes from "../../Routes";
import AppWrapper from "./App.style";

import {
  loginSuccess,
  loginFailure,
} from "../../redux/actions/Auth/AuthActions";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import configureStore from "../../redux/store";
const { persistor, store } = configureStore();

class App extends React.Component {
  componentDidMount() {
    if (sessionStorage.getItem("checkAuth") === "true") {
      let _userData = JSON.parse(sessionStorage.getItem("user"));

      this.props.loginSuccess(_userData);
      // history.push("/home");
    } else {
      this.props.loginFailure();
      history.push("/");
      localStorage.clear();
      sessionStorage.clear();
    }
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppWrapper>
            <Routes />
          </AppWrapper>
        </PersistGate>
      </Provider>
    );
  }
}

function mapStateToProps(dispatch, state) {
  return state;
}

const mapDispatchToProps = {
  loginSuccess,
  loginFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js